import { searchFormHelper } from './search-form';
import { formatter } from './util';

var medicalDeviceRzproHelper = (function ($) {
	var appendMedicalDeviceRzproTableRows = function (response) {
		$('.medical-device-rzpro-table .table').toggle(response.pagination.total > 0);
		$('.medical-device-rzpro-table .load-more').toggle(
			response.pagination.currentPage < response.pagination.totalPages
		);
		$('.medical-device-rzpro-table .no-results-container').toggle(response.pagination.total === 0);

		for (var i = 0; i < response.items.length; i++) {
			createMedicalDeviceTableRow(response.items[i]);
		}
	};

	var sortMedicalDeviceRzproTableRows = function (response) {
		$('.medical-device-rzpro-table .table').toggle(response.pagination.total > 0);
		$('.medical-device-rzpro-table .load-more').toggle(
			response.pagination.currentPage < response.pagination.totalPages
		);
		$('.medical-device-rzpro-table .no-results-container').toggle(response.pagination.total === 0);

		$('.medical-device-rzpro-table .table tbody').empty();

		for (var i = 0; i < response.items.length; i++) {
			createMedicalDeviceTableRow(response.items[i]);
		}
	};

	var createMedicalDeviceTableRow = function (rzproDevice) {
		var tableRow = $('<tr>');
		var detailUrl = location.pathname + '/' + encodeURIComponent(rzproDevice.id) + location.search;
		var detailLink = $('<a class="btn-detail">').attr('href', detailUrl).text('detail');

		function valueOrDash(value) {
			// We want to handle numeric 0 as a correct value, but replace `undefined` or `null` with placeholder dash
			return value === 0 ? value : value || '-';
		}

		function extractValue(medicalDevice, name) {
			if (medicalDevice.zpscau != null) {
				return valueOrDash(medicalDevice.zpscau[name]);
			}

			if (medicalDevice.szp != null) {
				return valueOrDash(medicalDevice.szp[name]);
			}

			return '-';
		}

		tableRow.append($('<td>').html('<strong>' + rzproDevice.name + '</strong>'));
		tableRow.append($('<td>').text(rzproDevice.manufacturer));
		tableRow.append($('<td>').text(rzproDevice.notificationBy));
		tableRow.append($('<td>').text(rzproDevice.evNum));
		tableRow.append($('<td>').text(rzproDevice.validFrom ? formatter.formatDate(rzproDevice.validFrom) : '-'));
		tableRow.append($('<td>').text(rzproDevice.validTo ? formatter.formatDate(rzproDevice.validTo) : '-'));
		tableRow.append($('<td>').text(rzproDevice.healthRisk));
		tableRow.append($('<td>').text(rzproDevice.version));
		tableRow.append($('<td class="item-last">').html(detailLink));

		tableRow.clickableRow('btn-detail');

		$('.table tbody').append(tableRow);
	};

	var getMedicalDeviceApiUrl = function () {
		var values = searchFormHelper.getSearchFormValues();
		var queryString = '';
		var operator = searchFormHelper.getOperatorValue();

		for (var i = 0; i < values.length; i++) {
			queryString +=
				(i === 0 ? '?' : '&') + encodeURIComponent(values[i].name) + '=' + encodeURIComponent(values[i].value);
		}

		queryString += (queryString === '' ? '?' : '&') + 'operator=' + encodeURIComponent(operator);

		return '/medical-devices/rzpro' + queryString;
	};

	return {
		appendMedicalDeviceRzproTableRows: appendMedicalDeviceRzproTableRows,
		sortMedicalDeviceRzproTableRows: sortMedicalDeviceRzproTableRows,
		getMedicalDeviceRzproApiUrl: getMedicalDeviceApiUrl,
	};
})(jQuery);

/**
 * Features of medical device rzpro search.
 */
var medicalDeviceRzproSearch = (function ($) {
	var root;

	var init = function () {
		root = $('.medical-device-rzpro-search');

		if (root.length === 0) {
			return;
		}

		var datagrid = {
			page: 1,
			order: searchFormHelper.getOrderValue() || 'default',
			sortDirection: searchFormHelper.getSortDirectionValue() || 'desc',
		};

		root.find('.search-form-container').searchForm();
		root.find('.table tbody tr').clickableRow('btn-detail');
		root
			.find('.medical-device-rzpro-table .btn-load-more')
			.loadMoreWithSort(
				medicalDeviceRzproHelper.getMedicalDeviceRzproApiUrl(),
				medicalDeviceRzproHelper.appendMedicalDeviceRzproTableRows,
				datagrid
			);
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of medical device detail.
 */
var medicalDeviceRzproDetail = (function ($) {
	var init = function () {
		var root = $('.medical-device-rzpro-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.detail-tabs a').tabs('.tab-content', 'item-act');
		root
			.find('.tab-content[data-tab=procedures] .btn-detail')
			.toggleTableDetails('.table-item-showmore', 'table-item-act');
	};

	return {
		init: init,
	};
})(jQuery);

export { medicalDeviceRzproHelper, medicalDeviceRzproSearch, medicalDeviceRzproDetail };
